import type { Captcha } from '@meizhen/shared/src/types/login'
import type { QueryParams } from '@meizhen/shared/src/types/page'
import type { Profile } from '@meizhen/shared/src/types/profile'
import { axios } from '@/api/axios'
import router from '@/router'

export async function verification() {
  return axios.get<Captcha>('/pub/captcha').then((res) => {
    return res.data
  })
}

export async function fetchCinema(params) {
  return axios.get('pub', { params }).then(res => res.data)
}

export async function login(params: QueryParams) {
  return axios.post('/pub/login', params).then((res) => {
    const { updateProfile } = useProfileStore()
    updateProfile(res.data)
  })
}

export async function uc() {
  return axios.get<Profile>('/uc/profile', { ignoreError: true }).then((res) => {
    const { updateProfile } = useProfileStore()
    updateProfile(res.data)
    return res.data
  })
}

export async function updateProfilePwd(params: QueryParams) {
  return axios.post('/uc/password', params)
}

export async function logout(): Promise<void> {
  return axios.post('/pub/logout').then(() => {
    const { updateProfile } = useProfileStore()
    updateProfile(null)
    void router.replace({
      name: 'Login',
    })
  })
}
